<script lang="ts" setup>
import type { VNodeChild } from 'vue';
import { hasSlotContent } from '../../utils';

defineSlots<{
  default?: () => VNodeChild;
  headerStart?: () => VNodeChild;
  headerEnd?: () => VNodeChild;
  footerStart?: () => VNodeChild;
  footerEnd?: () => VNodeChild;
}>();
</script>

<template>
  <div :class="$style.root">
    <div
      v-if="hasSlotContent($slots.headerStart) || hasSlotContent($slots.headerEnd)"
      :class="$style.header"
    >
      <div :class="$style.headerStart">
        <slot name="headerStart" />
      </div>
      <div :class="$style.headerEnd">
        <slot name="headerEnd" />
      </div>
    </div>
    <div :class="$style.body">
      <slot />
    </div>
    <div
      v-if="hasSlotContent($slots.footerStart) || hasSlotContent($slots.footerEnd)"
      :class="$style.footer"
    >
      <div :class="$style.footerStart">
        <slot name="footerStart" />
      </div>
      <div :class="$style.footerEnd">
        <slot name="footerEnd" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  border-radius: 10px;
  overflow: hidden;
  overflow-anchor: none;
  display: flex;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  border: 1px solid #f0f1f4;
  padding: 8px;
}

.header {
  padding: 0 0 12px;
}

.body {
  flex: 1 1 0%;
  overflow: auto;
  box-sizing: border-box;
}

.footer {
  padding: 20px 8px 2px;
}

.header,
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  box-sizing: border-box;
}

.headerStart,
.footerStart {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
</style>
